import React, { type FC, useMemo, useRef } from 'react';
import { useSelector } from 'react-redux';
import { CreativeTypes, Template } from '@bynder-studio/render-core';
import useCreativeModelFactory, { DesignConfig } from 'packages/hooks/useCreativeModelFactory';
import { useCreativeRenderer } from 'packages/hooks/useCreativeRenderer';
import { getFonts } from 'packages/store/user/user.selectors';
import { PresetThumbnailContainer, ThumbnailCanvas } from './PresetModal.styled';
import { buildPresetPage } from './utils';

type PresetThumbnailProps = {
    preset: Template;
};

const PresetThumbnail: FC<PresetThumbnailProps> = ({ preset }) => {
    const canvasWrapperRef = useRef<HTMLDivElement | null>(null);
    const fonts = useSelector(getFonts);

    const designConfig = useMemo<DesignConfig>(() => {
        const page = buildPresetPage(preset);

        return {
            template: {
                ...preset,
                pages: [page],
            },
            textStyles: preset.textStyles || {},
            contentProperties: preset.contentProperties || [],
            galleryFonts: [],
        };
    }, [preset]);

    const factory = useCreativeModelFactory(CreativeTypes.IMAGE, fonts, designConfig);
    useCreativeRenderer(factory, canvasWrapperRef);

    return (
        <PresetThumbnailContainer>
            <ThumbnailCanvas ref={canvasWrapperRef} />
        </PresetThumbnailContainer>
    );
};

export default PresetThumbnail;
